import React from 'react';
import { FlexBox, Typography } from '@agilepoint/wat-react-ux';
import { HelpLink, IHelpLinkProps } from 'common';

interface IHeaderProps extends IHelpLinkProps {
    headerTitle: string;
}

export const PageHeader = React.memo((props: IHeaderProps) => (
    <FlexBox justifyContent="space-between" width='calc(100% - 6px)'>
        <Typography.H4 title={props.headerTitle}>{props.headerTitle}</Typography.H4>
        <HelpLink id={props.id} />
    </FlexBox>
));
